/**
 * FE-PR-28 — admin publishes consent invalidation on CUSTOMER_CONSENT_CHANNEL (GAP-2-10).
 * Same-origin customer/kiosk tabs on the tenant host receive `consent-updated`.
 */
import {
  createCrossTabBus,
  CUSTOMER_CONSENT_CHANNEL,
  type CustomerConsentCrossTabMessage,
} from 'pi-kiosk-shared/crossTab';

export const adminCustomerConsentBus = createCrossTabBus<CustomerConsentCrossTabMessage>({
  channelName: CUSTOMER_CONSENT_CHANNEL,
});

export interface PublishAdminConsentInvalidatedInput {
  readonly tenantId: number;
  readonly tenantCode?: string;
}

export function publishAdminConsentInvalidated(
  input: PublishAdminConsentInvalidatedInput,
): void {
  adminCustomerConsentBus.publish({
    type: 'consent-updated',
    tenantId: input.tenantId,
    ...(input.tenantCode !== undefined && input.tenantCode.length > 0
      ? { tenantCode: input.tenantCode }
      : {}),
    source: 'admin',
  });
}
